import claudeIcon from '@/assets/claude-icon.png'
import { CAI_BRAND_SYSTEM_HREF, RefLink } from './primitives'

/** The two places the system lives, and why there are two. */
export function IntroResources() {
  return (
    <div className="mt-10">
      {/* Unboxed, like the rest of the intro — the columns carry the split. */}
      <div className="grid gap-8 sm:grid-cols-2">
        <div>
          <h3 className="text-ink font-semibold">Design System</h3>
          <p className="text-ink-500 mt-2 text-sm leading-relaxed">
            This page, including our coded components, tokens, variables, accessible for use in Claude Code,
            Claude Chat. This documentation is available to any AI tool you choose to build with, whether
            Claude, Codex, or Gemini.
          </p>
        </div>
        <div>
          <h3 className="text-ink font-semibold">Brand System</h3>
          <p className="text-ink-500 mt-2 text-sm leading-relaxed">
            A small snapshot of the Design System, accessible in Claude Design. Carrie keeps this snapshot up
            to date using <span className="text-ink font-mono text-xs">/design-sync</span> weekly. Claude
            Design tool cannot currently make use of an outside repo as its source of truth.
          </p>
          <div className="mt-3">
            <RefLink
              icon={claudeIcon}
              target={{ name: 'Open in Claude Design', href: CAI_BRAND_SYSTEM_HREF }}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
